/**
 * Frontend renderer registry. Keyed by visualization type string
 * (matches @deckspace/catalog VisualizationDefinition.type).
 *
 * Populated at app boot by web-app's catalog-bootstrap. ui-components
 * itself ships only pure renderers; nothing self-registers.
 */

import type { ComponentType, CSSProperties, ReactNode } from 'react';

export type RendererProps = Record<string, unknown> & {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
};

const renderers = new Map<string, ComponentType<RendererProps>>();

export function registerRenderer(type: string, Component: ComponentType<RendererProps>): void {
  renderers.set(type, Component);
}

export function getRenderer(type: string): ComponentType<RendererProps> | undefined {
  return renderers.get(type);
}

/** For tests / debugging. */
export function clearRenderers(): void {
  renderers.clear();
}

/** For tests / debugging. */
export function getRegisteredTypes(): string[] {
  return Array.from(renderers.keys());
}
